import script from "./BasicLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./BasicLayout.vue?vue&type=script&lang=ts&setup=true"

import "./BasicLayout.vue?vue&type=style&index=0&id=7a4bc7f5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a4bc7f5"]])

export default __exports__